import { SquareDotLoadingIndicator } from '@joor/design-system'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import styled from 'styled-components'

import {
  isLiteRetailer as isLiteRetailerSelector,
  isProBrand as isProBrandSelector,
} from 'store/currentUser/selectors'

import { useJoorPay } from '../../review.hooks'
import { useInvoiceHasBeenSent } from '../../review.queries'
import LiteRetailerPayView from './LiteRetailerPayView'
import ProBrandPayView from './ProBrandPayView'
import OrphanOrderView from './components/OrphanOrderView'

type Props = {
  brandId?: string
  brandName?: string
  orderId?: string
  loading?: boolean
  shouldRedirect?: boolean
  redirectUrl?: string
  isOrphanOrder?: boolean
  openModal?: () => void
}

const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
`

export const PayView = ({
  brandId,
  brandName,
  loading,
  shouldRedirect,
  redirectUrl,
  isOrphanOrder,
  openModal,
}: Props) => {
  const {
    reachProvider,
    joorPayUseReach,
    loading: joorPayInfoLoading,
  } = useJoorPay(brandId)
  const isProBrand = useSelector(isProBrandSelector)
  const isLiteRetailer = useSelector(isLiteRetailerSelector)

  const { invoicesSentLoading, hasInvoiceBeenSent } = useInvoiceHasBeenSent()

  if (loading || invoicesSentLoading || joorPayInfoLoading) {
    return (
      <LoaderWrapper>
        <SquareDotLoadingIndicator />
      </LoaderWrapper>
    )
  }

  if (shouldRedirect && redirectUrl) {
    return <Navigate to={redirectUrl} />
  }

  if (isOrphanOrder) {
    return <OrphanOrderView openModal={openModal} />
  }

  if (isProBrand) {
    return <ProBrandPayView paymentProvider={reachProvider ?? null} />
  }

  if (isLiteRetailer) {
    return (
      <LiteRetailerPayView
        hasInvoiceBeenSent={hasInvoiceBeenSent}
        paymentProvider={reachProvider ?? null}
        joorPayUseReach={joorPayUseReach}
        brandName={brandName}
      />
    )
  }

  return null
}
